// Extract a user-friendly message from an axios error's `response.data.detail`.
// Backend returns either a plain string or a Pydantic validation list.

type PydanticValidationItem = { msg?: string };

type AxiosLikeError = {
  response?: {
    data?: {
      detail?: string | PydanticValidationItem[];
    };
  };
  request?: unknown;
};

export function isNetworkError(err: unknown): boolean {
  const e = err as AxiosLikeError & { request?: unknown };
  // True network error (no response at all) or proxy couldn't reach the backend
  if (!!e.request && !e.response) return true;
  const status = (e.response as { status?: number } | undefined)?.status;
  return status === 502 || status === 503 || status === 504;
}

export default function detailMessage(err: AxiosLikeError, fallback: string): string {
  const detail = err.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).join(", ");
  return fallback;
}
